













import Vue from "vue";
import { required } from "vuelidate/lib/validators";

import dialog from "@/common/mixins/dialog";
import ShippopCodEditorForm from "../components/ShippopCodEditorForm.vue";
import { ShippopCreateCodForm } from "../forms/ShippopCreateCodForm";

export default Vue.extend({
  mixins: [dialog],
  components: {
    ShippopCodEditorForm
  },
  validations: {
    shippopCreateCodForm: {
      email: { required }
    }
  },
  data() {
    const shippopCreateCodForm: ShippopCreateCodForm = {
      email: ""
    };

    return { shippopCreateCodForm };
  },
  methods: {
    async createShippopCod() {
      try {
        const {
          data
        } = await (this as any).$dep.shippopUseCase.createCodShippop(
          this.shippopCreateCodForm
        );

        if (
          await (this as any).alertSuccess(
            "Success",
            "สร้าง Link Shippop COD สำเร็จ"
          )
        ) {
          this.clear();
          window.open(data.link, "_blank");
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถสร้าง Link Shippop COD ได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to create Link Shippop COD",
        "คุณต้องการสร้าง Link Shippop COD หรือไม่ ?"
      );

      if (isConfirmed) {
        await this.createShippopCod();
      }
    },
    clear() {
      this.$v.$reset();

      this.shippopCreateCodForm = {
        email: ""
      };
    }
  }
});
